import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { LayoutContentComponent } from '../../core/layout/layout-content/layout-content.component';
import { LayoutFirstLevelComponent } from '../../core/layout/layout-first-level/layout-first-level.component';
import { LayoutTitleComponent } from '../../core/layout/layout-title/layout-title.component';
import { NotificationListComponent } from '../../core/notification/notification-list/notification-list.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  imports: [
    LayoutContentComponent,
    LayoutFirstLevelComponent,
    LayoutTitleComponent,
    NotificationListComponent,
    TranslatePipe,
  ],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsPage {}
